
/**
 * Get logged in user
 */
export function me(state) {
  return state.user;
}
